export default __webpack_public_path__ + "static/media/circulo3.d1892db2.svg";